import { render, staticRenderFns } from "./yngtzyzyxy.vue?vue&type=template&id=33e1e6ac&scoped=true&"
import script from "./yngtzyzyxy.vue?vue&type=script&lang=js&"
export * from "./yngtzyzyxy.vue?vue&type=script&lang=js&"
import style0 from "./yngtzyzyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./yngtzyzyxy.vue?vue&type=style&index=1&id=33e1e6ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e1e6ac",
  null
  
)

export default component.exports